<template>
    <div class="bg-gray relative z-0">
        <div class="page-container">
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-10">
                    Confirm Sign Out
                </h1>

                <div class="mt-10 flex flex-col md:flex-row md:items-center">
                    <a @click.prevent="doSignOut" class="btn">Sign Out</a>

                    <a
                            @click="$router.go(-1)"
                            class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer text-center">Go Back</a>

                </div>
            </div>
        </div>
    </div>


</template>

<script charset="utf-8">
    import Vuex from 'vuex';

    export default {
        name: 'SignOut',

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapActions('profile', {
                setUser: 'setUser',
                logout: 'logout',
            }),
            ...Vuex.mapMutations('equipments', {
                clearItems: 'clearItems',
                clearCurrentItem: 'clearCurrentItem',
            }),
            ...Vuex.mapMutations('accounts', {
                clearClients: 'clearClients',
                clearUsers: 'clearUsers',
            }),
            doSignOut() {
                this.logout();
                this.clearItems();
                this.clearCurrentItem();
                this.clearClients();
                this.clearUsers();
                this.$router.push({ name: 'signIn' });
            }
        }
    }
</script>
